import { render, staticRenderFns } from "./OsBusinessErrorDialog.vue?vue&type=template&id=0c7c9efe&scoped=true"
import script from "./OsBusinessErrorDialog.vue?vue&type=script&lang=ts"
export * from "./OsBusinessErrorDialog.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c7c9efe",
  null
  
)

export default component.exports